import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  performInputLogin,
  performInputPassword,
  performLogin,
  clearForm
} from '../Actions/ActionsLogin'
import ViewLogin from '../Components/ViewLogin'

class ContainerLogin extends Component {

  componentDidMount() {

  }

  render() {
    return (
      <ViewLogin
        performInputLogin={this.props.performInputLogin}
        performInputPassword={this.props.performInputPassword}
        performLogin={this.props.performLogin}
        error={this.props.error}
        clearForm={this.props.clearForm}
        login={this.props.login}
        password={this.props.password}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  error: state.ReducerLogin.error,
  login: state.ReducerLogin.login,
  password: state.ReducerLogin.password,
})

const mapDispatchToProps = (dispatch) => {
  return {
    performInputLogin: (login) => {
      dispatch(performInputLogin(login))
    },
    performInputPassword: (password) => {
      dispatch(performInputPassword(password))
    },
    clearForm: () => {
      dispatch(clearForm())
    },
    performLogin: () => {
      dispatch(performLogin())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContainerLogin)



// WEBPACK FOOTER //
// ./src/Containers/ContainerLogin.js